// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1BBjK","bigColWidth":"Table_bigColWidth__24XE6","biggerColWidth":"Table_biggerColWidth__i-1Yg","row":"Table_row__VyVQg","col":"Table_col__3QuSE"};